import React, { useEffect } from "react";
import useNearScreen from "app/hooks/useNearScreen";

const LastIntersectedElement = ({ rootRef, onNearScreen }) => {
  const [isNearScreen, fromRef] = useNearScreen({
    root: rootRef.current,
    rootMargin: "50px",
    observeOnce: false
  });

  useEffect(() => {
    if (!isNearScreen) return;
    if (onNearScreen) onNearScreen();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNearScreen]);

  return <div ref={fromRef} />;
};

export default LastIntersectedElement;
